<template>
    <div>
        <b-row>
            <b-col>
                <b-button v-b-modal.modal-prevent-closing
                  variant="outline-primary">Attach Document</b-button>
            </b-col>
        </b-row>
        
        <b-modal  hide-footer
            id="modal-prevent-closing"
            ref="modal"
            title="Add File Attachment"
            @show="resetModal"
            @hidden="resetModal"
            @ok="handleOk">

            <form ref="form" @submit.stop.prevent="handleSubmit">
                <b-form-group
                    :state="$v.type.$dirty ? !$v.type.$error : null"
                    label="Type of Attachment"
                    label-for="type-input"
                    invalid-feedback="Type of Attachment is required">
                    <b-form-select id="type-input" v-model="type" 
                      :state="$v.type.$dirty ? !$v.type.$error : null"
                      :options="attachmentDropdown()">
                      <template v-slot:first>
                          <option :value="null" disabled>-- Please select an option --</option>
                      </template>
                  </b-form-select>
                </b-form-group>

                <b-form-group
                      :state="$v.file.$dirty ? !$v.file.$error : null"
                    label="File to Attach"
                    label-for="file-input"
                    invalid-feedback="File Attachment is required">
                    <b-form-file
                        id="file-input"
                        v-model="file"
                      :state="$v.file.$dirty ? !$v.file.$error : null"
                        placeholder="Choose a file or drop it here..."
                        drop-placeholder="Drop file here...">
                    </b-form-file>
                </b-form-group>

                <b-button type="submit" variant="primary">Submit</b-button>
            </form>
        </b-modal>
    </div>
</template>

<script>
    import axios from "axios"
    import { required, email, minLength, maxLength, numeric } from 'vuelidate/lib/validators'

  export default {
     props: {
        id: [String, Number],
        requestType: {},
        requestStatus: {}
     },

    data() {
      return {
        type: '',
        file: null,
        attachmentTypeOptions: [],
      }
    },

    validations: {
         file: { required },
         type: { required }
    },

    created() {
       this.loadAttachmentReqs()
    },

    methods: {
      checkFormValidity() {
        const valid = this.$refs.form.checkValidity()
        this.nameState = valid
        return valid
      },
      loadAttachmentReqs() {
        axios.post(`${process.env.VUE_APP_API_BASE_URL}/attachment/requirements` , {statusCode: this.requestStatus.code})
            .then(response => {
              for (let i=0; i<response.data.length; i++) {
                let index = this.attachmentTypeOptions.findIndex(e => e.value === response.data[i].attachmentTypeValue.code)
                if (index < 0) {
                  let obj = {
                    value: response.data[i].attachmentTypeValue.code,
                    text: response.data[i].attachmentTypeValue.description,
                    required: [],
                    optional: []
                  }
                  if (response.data[i].required) {
                    obj.required.push(response.data[i].requestTypeValue.code)
                  } else {
                    obj.optional.push(response.data[i].requestTypeValue.code)
                  }
                  this.attachmentTypeOptions.push(obj)
                } else {
                  if (response.data[i].required) {
                    this.attachmentTypeOptions[index].required.push(response.data[i].requestTypeValue.code)
                  } else {
                    this.attachmentTypeOptions[index].optional.push(response.data[i].requestTypeValue.code)
                  }
                }
              }
            })
      },
      attachmentDropdown() {
        let dropdown = [];
        for (let i=0; i<this.attachmentTypeOptions.length; i++) {
          if (this.attachmentTypeOptions[i].required.includes(this.requestType.code) ||
              this.attachmentTypeOptions[i].optional.includes(this.requestType.code)) {
            dropdown.push(this.attachmentTypeOptions[i])
          }
        }
        return dropdown;
      },
      resetModal() {
        this.name = ''
        this.nameState = null
      },
      handleOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },
      handleSubmit() {
        this.$v.$touch()
            if (this.$v.$invalid) {
                return
            }
        
        const fd2 = new FormData()
          fd2.append('file', this.file)
          fd2.append('type', this.type)
          fd2.append('id', this.id ? this.id : '')
        axios.post(`${process.env.VUE_APP_API_BASE_URL}/attachment`, fd2, {params :{form: true}})
          .then(response => {
            this.file = null
            this.type = ''
            this.id = ''
            this.$v.$reset()
            // Hide the modal manually
            this.$emit('attachment-added', response.data)
        this.$nextTick(() => {
          this.$bvModal.hide('modal-prevent-closing')
        })
          })
    }
  }
  }
</script>